// Single source for the API base URL so api.ts, authRefresh.ts, and
// sseClient.ts all read (and, if it ever changes shape, normalize) it the
// same way.
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL as string;
